import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-formfield p-component'
};

export default BaseStyle.extend({
    name: 'formfield',
    classes
});
